/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "customFields": {
    "support": {
      "enabled": true,
      "baseUrl": "https://suporte.mupag.com.br",
      "inboxIdentifier": "cBznP2eCRqkW7qp7cp2MVyNA"
    }
  },
  "title": "MuPag Docs",
  "tagline": "Documentação operacional para checkout, PIX e cobrança recorrente.",
  "favicon": "img/brand/mupag-logomark.png",
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": true,
      "useCssCascadeLayers": true,
      "siteStorageNamespacing": true,
      "fasterByDefault": true,
      "mdx1CompatDisabledByDefault": true
    },
    "experimental_vcs": {},
    "experimental_router": "browser",
    "faster": {
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "swcHtmlMinimizer": true,
      "lightningCssMinimizer": true,
      "mdxCrossCompilerCache": true,
      "rspackBundler": true,
      "rspackPersistentCache": true,
      "ssgWorkerThreads": true,
      "gitEagerVcs": true
    }
  },
  "url": "https://docs.mupag.com.br",
  "baseUrl": "/",
  "trailingSlash": false,
  "organizationName": "mupaybr",
  "projectName": "mupag",
  "onBrokenLinks": "throw",
  "markdown": {
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    },
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": false,
      "admonitions": false,
      "headingIds": false
    },
    "anchors": {
      "maintainCase": false
    }
  },
  "i18n": {
    "defaultLocale": "pt-BR",
    "locales": [
      "pt-BR",
      "en"
    ],
    "localeConfigs": {
      "pt-BR": {
        "label": "PT-BR",
        "htmlLang": "pt-BR"
      },
      "en": {
        "label": "English",
        "htmlLang": "en-US"
      }
    },
    "path": "i18n"
  },
  "themes": [
    "docusaurus-theme-openapi-docs"
  ],
  "plugins": [
    [
      "docusaurus-plugin-openapi-docs",
      {
        "id": "api",
        "docsPluginId": "classic",
        "config": {
          "public": {
            "specPath": "../../docs/openapi/public-v1.yaml",
            "outputDir": "docs/api-reference/public",
            "hideSendButton": true,
            "sidebarOptions": {
              "groupPathsBy": "tag"
            }
          },
          "publicEn": {
            "specPath": ".generated/openapi/public-v1.en.yaml",
            "outputDir": "i18n/en/docusaurus-plugin-content-docs/current/api-reference/public",
            "hideSendButton": true,
            "sidebarOptions": {
              "groupPathsBy": "tag"
            }
          }
        }
      }
    ],
    [
      "/workspace/frontend/docs-site/node_modules/@easyops-cn/docusaurus-search-local/dist/server/server/index.js",
      {
        "indexDocs": true,
        "indexBlog": false,
        "docsRouteBasePath": "docs",
        "language": [
          "pt",
          "en"
        ],
        "hashed": true
      }
    ],
    null,
    null
  ],
  "presets": [
    [
      "classic",
      {
        "docs": {
          "routeBasePath": "docs",
          "sidebarPath": "./sidebars.ts",
          "docItemComponent": "@theme/ApiItem"
        },
        "blog": false,
        "theme": {
          "customCss": "./src/css/custom.css"
        }
      }
    ]
  ],
  "themeConfig": {
    "languageTabs": [
      {
        "language": "curl",
        "label": "HTTP · cURL"
      }
    ],
    "image": "img/brand/mupag-logo.png",
    "colorMode": {
      "defaultMode": "dark",
      "disableSwitch": false,
      "respectPrefersColorScheme": false
    },
    "navbar": {
      "title": "Docs",
      "logo": {
        "alt": "MuPag",
        "src": "img/brand/mupag-logo-with-mascot.png",
        "width": 124,
        "height": 32
      },
      "items": [
        {
          "to": "/docs/start/overview",
          "label": "Começar",
          "position": "left",
          "className": "navbar-doc-link"
        },
        {
          "to": "/docs/payments/charges",
          "label": "Guias",
          "position": "left",
          "className": "navbar-doc-link"
        },
        {
          "to": "/docs/webhooks/overview",
          "label": "Webhooks",
          "position": "left",
          "className": "navbar-doc-link"
        },
        {
          "to": "/docs/api-reference/overview",
          "label": "Referência",
          "position": "left",
          "className": "navbar-doc-link"
        },
        {
          "to": "/docs/tools/sdk-and-tools",
          "label": "SDKs/Ferramentas",
          "position": "left",
          "className": "navbar-doc-link"
        },
        {
          "to": "/docs/changelog",
          "label": "Changelog",
          "position": "left",
          "className": "navbar-doc-link"
        },
        {
          "type": "search",
          "position": "right"
        },
        {
          "to": "/docs/api-reference/overview",
          "label": "v1",
          "position": "right"
        },
        {
          "type": "localeDropdown",
          "position": "right",
          "dropdownItemsBefore": [],
          "dropdownItemsAfter": []
        },
        {
          "href": "https://qa.dashboard.mupag.com.br/app",
          "label": "Dashboard",
          "position": "right"
        },
        {
          "label": "Status/Suporte",
          "position": "right",
          "items": [
            {
              "to": "/docs/operations/status-support-feedback",
              "label": "Status"
            },
            {
              "to": "/docs/operations/status-support-feedback",
              "label": "Suporte"
            },
            {
              "to": "/docs/operations/status-support-feedback",
              "label": "Feedback"
            }
          ]
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "light",
      "links": [
        {
          "title": "Começar",
          "items": [
            {
              "label": "Visão geral",
              "to": "/docs/start/overview"
            },
            {
              "label": "Início rápido em 5 minutos",
              "to": "/docs/start/quickstart"
            }
          ]
        },
        {
          "title": "Guias",
          "items": [
            {
              "label": "Cobranças e PIX",
              "to": "/docs/payments/charges"
            },
            {
              "label": "Assinaturas",
              "to": "/docs/subscriptions/overview"
            },
            {
              "label": "Webhooks",
              "to": "/docs/webhooks/overview"
            }
          ]
        },
        {
          "title": "Operações",
          "items": [
            {
              "label": "Baixar OpenAPI",
              "href": "https://docs.mupag.com.br/openapi/public-v1.yaml"
            },
            {
              "label": "Coleção Postman",
              "href": "https://docs.mupag.com.br/postman/mupag-public-api.postman_collection.json"
            },
            {
              "label": "Status, suporte e feedback",
              "to": "/docs/operations/status-support-feedback"
            }
          ]
        }
      ],
      "copyright": "Copyright © 2026 MuPag."
    },
    "prism": {
      "additionalLanguages": [
        "java",
        "python",
        "php",
        "go"
      ],
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#9CDCFE",
          "backgroundColor": "#1E1E1E"
        },
        "styles": [
          {
            "types": [
              "prolog"
            ],
            "style": {
              "color": "rgb(0, 0, 128)"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(106, 153, 85)"
            }
          },
          {
            "types": [
              "builtin",
              "changed",
              "keyword",
              "interpolation-punctuation"
            ],
            "style": {
              "color": "rgb(86, 156, 214)"
            }
          },
          {
            "types": [
              "number",
              "inserted"
            ],
            "style": {
              "color": "rgb(181, 206, 168)"
            }
          },
          {
            "types": [
              "constant"
            ],
            "style": {
              "color": "rgb(100, 102, 149)"
            }
          },
          {
            "types": [
              "attr-name",
              "variable"
            ],
            "style": {
              "color": "rgb(156, 220, 254)"
            }
          },
          {
            "types": [
              "deleted",
              "string",
              "attr-value",
              "template-punctuation"
            ],
            "style": {
              "color": "rgb(206, 145, 120)"
            }
          },
          {
            "types": [
              "selector"
            ],
            "style": {
              "color": "rgb(215, 186, 125)"
            }
          },
          {
            "types": [
              "tag"
            ],
            "style": {
              "color": "rgb(78, 201, 176)"
            }
          },
          {
            "types": [
              "tag"
            ],
            "languages": [
              "markup"
            ],
            "style": {
              "color": "rgb(86, 156, 214)"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "rgb(212, 212, 212)"
            }
          },
          {
            "types": [
              "punctuation"
            ],
            "languages": [
              "markup"
            ],
            "style": {
              "color": "#808080"
            }
          },
          {
            "types": [
              "function"
            ],
            "style": {
              "color": "rgb(220, 220, 170)"
            }
          },
          {
            "types": [
              "class-name"
            ],
            "style": {
              "color": "rgb(78, 201, 176)"
            }
          },
          {
            "types": [
              "char"
            ],
            "style": {
              "color": "rgb(209, 105, 105)"
            }
          }
        ]
      },
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "storage": {
    "type": "localStorage",
    "namespace": true
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false
};
